<template>
  <v-app-bar class="header" app fixed elevation="0" height="100">
    <div class="headerContentWrap">
      <div class="headerBtn">
        <div class="headerFlyIn"></div>
        <v-btn @click="directMainPage">
          <igrosLogo/>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn v-if="isLogged && this.restrictions.pw !== 0"
             class="headerBtn"
             @click="this.setSideDrawerState"
      >
        <menuIcon class="hover"/>
      </v-btn>
      <v-btn v-if="isLogged && this.restrictions.pw !== 0 && !getInventoryMode && !getCurrentActiveMode"
             class="headerBtn"
             v-bind:class="{hidden: !cartVisible}"
             @click="this.setCartDrawerState"
      >
        <v-badge
            v-if="cartVisible"
            color="white"
            :content="this.getCartContent"
        >
          <cartIcon/>
        </v-badge>
      </v-btn>

      <v-btn v-if="isLogged && this.restrictions.pw !== 0 && getInventoryMode && !getCurrentActiveMode"
             class="headerBtn"
             @click="this.setInventoryDrawer"
      >
        <inventory-icon/>
      </v-btn>
      <v-btn v-if="isLogged && this.restrictions.pw !== 0 && getCurrentActiveMode === 'mhd'"
             class="headerBtn"
             @click="setMHDInventoryDrawer"
      >
          <mdh-icon style="width: 50px; color: black;"/>
      </v-btn>
      <v-btn v-if="!isLogged"
             class="imprintHeaderBtn"
             @click="this.goToImprint"
      >
        Impressum
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex';
import router from '@/router'
import igrosLogo from "@/assets/logo/igrosLogo";
import MenuIcon from "@/assets/navigation/menuIcon";
import CartIcon from "@/assets/navigation/cartIcon";
import InventoryIcon from "@/assets/navigation/inventoryIcon";
import MdhIcon from "@/assets/mhd/mdhIcon.vue";

export default {
  name: "Header",
  components: {MdhIcon, InventoryIcon, CartIcon, MenuIcon, igrosLogo},
  methods: {
    ...mapActions({
      setOverlay: 'setOverlay',
      setCartDrawerState: 'setCartDrawerState',
      retrieveCartContent: 'retrieveCartContent',
      setLoadingState: 'setLoadingState',
      goToImprint: 'goToImprint',
      logout: 'logout',
    }),

    ...mapMutations({
      setSideDrawerState: 'setSideDrawerState'
    }),

    ...mapMutations('inventory', {
      setInventoryDrawerState: 'setInventoryDrawerState'
    }),

    ...mapMutations('mhdInventory', {
        setMHDInventoryDrawerState: 'setMHDInventoryDrawerState'
    }),

    setMHDInventoryDrawer() {
        this.setMHDInventoryDrawerState(true)
    },

    setInventoryDrawer() {
      this.setInventoryDrawerState(true)
    },

    showCartDrawer() {
      this.retrieveCartContent()
      this.setCartDrawerState()
      this.setLoadingState(false)
    },

    directMainPage() {
      if(this.restrictions.pw === 0) {
        this.logout()
        router.push({name: 'Login'})
      }
      else if(this.getUserRole !== 2) {
        router.push({name: 'LastArticle'})
      }
      else if(this.getUserRole === 2) {
        router.push({name: 'depositActions'})
      }
    }
  },

  computed: {
    ...mapGetters({
      isLogged: 'isLogged',
      getCartContent: 'getCartContent',
      getUserRole: 'getUserRole',
      getCurrentActiveMode: 'getCurrentActiveMode'
    }),

    ...mapGetters('inventory', {
      getInventoryMode: 'getInventoryMode'
    }),

    ...mapState({
      restrictions: 'restrictions'
    }),

    cartVisible() {
      if(this.getUserRole === 2) {
        return false
      }
      else {
        return true
      }
    },
  },
}
</script>

<style>
  .header .v-toolbar__content {
    padding-bottom: 0px;
    padding-top: 0px;
    margin: auto;
  }
  .headerContentWrap {
    display: flex;
    width: 100%;
    height: 90%;
    position: relative;
    bottom: -5px;
    align-items: center;
  }

  .v-badge__badge {
    color: black!important;
  }

  .header.v-sheet {
    max-width: 940px;
    margin: auto;
    overflow: hidden;

    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12)!important
  }
</style>
